import React, { useMemo } from 'react';
import moment from 'moment';

interface MessageProps {
  isMine: boolean;
  message: any;
}

const Message = (props: MessageProps) => {
  const {
    isMine,
    message
  } = props;

  const createdTime =  useMemo(() => moment(message?.created_time), [message]);

  const timeFormat = useMemo(() => createdTime.isBefore(moment().startOf('day')) ? 'M/D/YY, hh:mm A' : 'hh:mm A', [message]);

  return (
    <div className={`message-container ${isMine && 'mine'}`}>
      <div className={`message-inner-container ${isMine && 'mine'}`}>
        <div className="message-content">{message.contents}</div>
        <div className={`message-data-container ${isMine && 'mine'}`}>
          <span className="message-date text-nowrap">
            {createdTime.format(timeFormat)}
          </span>
          {message?.author ? <span className={`message-author ${isMine && 'mine'}`}>{message.author}</span> : ''}
        </div>
      </div>
    </div>
  );
}

export default Message;
